// extracted by mini-css-extract-plugin
export var content = "_np-1";
export var fullScreen = "_np-0";